import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './shared/services';
import { DxButtonModule, DxDataGridModule, DxDateBoxModule, DxFormModule, DxLoadPanelModule } from 'devextreme-angular';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

const routes: Routes = [
  {
    path: 'survey',
    loadChildren: () => import('./pages/survey/survey.module').then(m => m.SurveyModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login-form/login-form.module').then(m => m.LoginFormModule)
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true }), DxDataGridModule, DxFormModule, DxButtonModule, DxDateBoxModule, FlexLayoutModule, 
    CommonModule, MatButtonModule, DxLoadPanelModule],
  providers: [AuthGuardService],
  exports: [RouterModule],
  declarations: [  ]
})
export class AppRoutingModule { }
